import React, { useEffect, useState, Fragment } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import Wrapper from '../../../components/Wrapper/Wrapper';
import { tripTableHeight, tableHeightWithSparkline, tableHeightWithSparklineSingle } from "../../../../styleVariables";
import { connect } from "react-redux";
import TopCard from '../../../components/TopCard/TopCard';
import TapLayout from '../../../components/PageLayout/TabLayOut';
import Grid from '@material-ui/core/Grid';
import MUIDataTable from "mui-datatables";
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { getSinglePartyLedgerData, getSinglePartyPDFReport } from '../../../../store/actions/homeActionCreator';
import { getTripSparkLine, getPartyPayments, getSinglePartyPaymentDetails, updatePaymentsTabFilter } from '../../../../store/actions/partiesActionCreator';
import { numberFormat, getTripStartDateFilterValues, getDateInStringDDMMMYYYY, getRequestTimeInMillis } from "../../../../utils/utils";
import {
  TRIP_ACTIONS,
  TRIP_STATUS_DIALOG_TITLES,
  TRIP_STATUS_DIALOG_LABELS,
  TRIP_FILTER_STATUS,
  TRIP_FILTER_STATUS_MAPPING,
  PAYMENT_CHIPS,
  TRIP_STATUS_LABELS,
  TRIP_TRANSACTION_FILTER,
  TRIP_TRANSACTION_FILTER_LIST
} from "../../../../store/constants";
import { trackEvent } from '../../../../analytics';
import useStyles from '../../css/listing';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import ActionButton from '../../../components/Actions/ActionButton';
import ColumnActions from '../../../components/Actions/ColumnActions';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import Button from '@material-ui/core/Button';
import ReportsDialog from '../../../components/ReportsDialog/ReportsDialog';
import PaymentTabFilter from '../../../components/FilterComponent/PaymentTabFilter';
import DateFilter from '../../../components/FilterComponent/DateFilter';
import CustomDateFilterDialog from '../../../components/FilterComponent/CustomDateFilter';
import * as logger from "../../../../logger";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/core/styles";
import EditPartyPayment from '../../../components/Party/AddPartyPayment';
import TripActionDialog from '../../../components/Trip/TripActionDialog';
import clsx from 'clsx';
import PaymentDetailsSideBar from '../../../components/Supplier/PaymentDetailsSideBar';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { Waypoint } from "react-waypoint";
import { debounce } from 'lodash';
import { defaultPageNo, defaultPageSize, defaultDebounceMs } from '../../../../paginationVariables';
import PassBookReportDialog from '../../../components/ReportsDialog/PassBookReportDialog';
import OpeningBalanceDetailsSideBar from '../../../components/Trip/OpeningBalanceDetailsSideBar';


const theme = createMuiTheme({
  // MUIDataTableToolbar: {
  //   root: {
  //     display: 'block'
  //   }
  // }
});


const PaymentsTab = ({ user,
  location,
  dispatchGetSinglePartyTripSparkLine,
  parties,
  dispatchGetSinglePartyPayments,
  dispatchGetSinglePartyPaymentDetails,
  dispatchUpdatePaymentsTabFilter,
}) => {

  const [changeFlag, setChangeFlag] = useState(false);

  let history = useHistory();
  const classes = useStyles();
  let path = location && location.pathname ? location.pathname.split("/") : [];
  let partId = "";
  if (path[path.length - 1]) {
    partId = path[path.length - 1];
  }
  const partyLedgerRequestData = {
    fleetOwnerId: user.userInfo.entityId,
    // pageNo: 1,
    // pageSize: 10,
  };
  var dateFilterValues = getTripStartDateFilterValues();
  // const [selectedFilterTransaction, setSelectedFilterTransaction] = React.useState(parties.paymentTabFilter.selectedFilterTransaction);
  // const [selectedFilterDate, setSelectedFilterDate] = React.useState(parties.paymentTabFilter.selectedFilterDate);

  const [selectedFilterTransaction, setSelectedFilterTransaction] = React.useState("TRIPS_PAYMENTS");
  const [selectedFilterDate, setSelectedFilterDate] = React.useState("ALL_MONTHS");
  const [editPartyPaymentOpen, setEditPartyPaymentOpen] = useState(false);
  const [editPartyAdvanceOpen, setEditAdvanceOpen] = useState(false);
  const [cashFlowItem, setCashFlowItem] = React.useState(null);
  const [customFilter, setCustomFilter] = useState(false);
  const [customFilterValue, setCustomFilterValue] = useState({});
  const [paymentRowData, setPaymentRowData] = useState({});
  const [paymentSideBar, setPaymentSideBar] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [currentPageNo, setCurrentPageNo] = useState(defaultPageNo);
  const [currentPageSize, setCurrentPageSize] = useState(defaultPageSize);
  const [partyPaymentLedger, setPartyPaymentLedger] = useState([]);
  const [loadingText, setLoadingText] = useState("Sorry, no Payments found");
  const [passbookPdfOpen, setPassbookPdfOpen] = useState(false)
  const [selectedRow,setSelectedRow] = useState("");
  const [detailsOpen,setDetailsOpen] = useState("");

  const handlePaymentDetailsClose = () => {
    setSelectedRow("");
    setDetailsOpen(false);
    fetchPayments();
  }

  const handleTransactDelete = () => {
      setSelectedRow("")
      setDetailsOpen(false);
      fetchPayments();
  }
  const handleEditPartyPaymentOpen = (data) => {
    if (data && data.id) {
      dispatchGetSinglePartyPaymentDetails(
        Number(partId),
        data.id,
        (response) => {
          if (response && response.status && response.status && response.status.code && response.status.code === 200) {
            setEditPartyPaymentOpen(true)
          }
        },
        () => {

        });
    }
  };
  let editPartyAdvance = {
    action: 'edit_party_advance',
    label: 'Update Advance',
    confirmText: 'Update Advance',
    tabsFormat: false
  }
  const handleEditPartyAdvanceOpen = (data) => {
    if (data && data.id) {
      /*data = {
        ...data,
        receivedByDriver:data.isPaidToDriver?data.isPaidToDriver:false
      }*/
      dispatchGetSinglePartyPaymentDetails(
        Number(partId),
        data.id,
        (response) => {
          if (response && response.status && response.status && response.status.code && response.status.code === 200) {
            let data = response.response;
            data = {
              ...data,
              receivedByDriver: data.isPaidToDriver ? data.isPaidToDriver : false,
              dateDirect: new Date(data.paymentDate)
            }
            if (data && data.attributedTrips && data.attributedTrips[0] && data.attributedTrips[0].tripId) {
              data.tripId = data.attributedTrips[0].tripId;
              //setCashFlowItem(data);
              //setEditAdvanceOpen(true);
              goToTripView(data.attributedTrips[0])
            }
          }
        },
        () => {

        });
    }
  };
  const onSearchBlur = debounce(query => {
    setLoadingText("Loading........");
    setPartyPaymentLedger([]);
    setCurrentPageNo(defaultPageNo);
    fetchPayments(false, query)
  }, user && user.configs && user.configs.dwebSearchBebounceMs ? parseInt(user.configs.dwebSearchBebounceMs) : defaultDebounceMs);

  const getPaginatedData = () => {
    fetchPayments(true)
  }

  const fetchPayments = (pagination, search) => {
    if (partId) {
      var singlePartyLedgerRequestData = {
        ...{ customerId: Number(partId) },
        ...{ transactionType: TRIP_TRANSACTION_FILTER[selectedFilterTransaction] },
        ...{ startDateRange: dateFilterValues[selectedFilterDate]["startDateRange"] },
        pageNo: defaultPageNo,
        pageSize: defaultPageSize,
        searchText: searchText,
      };
      if (pagination) {
        singlePartyLedgerRequestData = {
          ...singlePartyLedgerRequestData,
          pageNo: currentPageNo + 1,
          pageSize: currentPageSize,
          searchText: searchText,
          merge: true
        }
      }
      if (search) {
        singlePartyLedgerRequestData.searchText = search && search == "null" ? "" : search;
      }
      let sparkLineRequets = {
        filters: {
          ...{ customerId: partId }
        }
      }

      if (customFilterValue && customFilterValue.startTimeEpoch) {
        singlePartyLedgerRequestData.startDateRange = customFilterValue;
      }

      dispatchGetSinglePartyTripSparkLine(sparkLineRequets, () => {
        dispatchGetSinglePartyPayments(singlePartyLedgerRequestData,
          () => {
            setLoadingText("Sorry, no Payments found");
          },
          () => {
            setLoadingText("Sorry, no Payments found");
          }
        );
      }, () => {

      });
    }
  }
  const handleEditPartyPaymentClose = (status) => {
    setEditPartyPaymentOpen(false);
    fetchPayments();
  };
  const handleEditPartyPaymentSave = (status) => {
    setEditPartyPaymentOpen(false);
    fetchPayments();
  };
  const handleOnUpdateSuccess = (status) => {
    setEditAdvanceOpen(status);
    fetchPayments();
  }
  const handleEditCashflowActionClose = (status) => {
    setEditAdvanceOpen(status);
    fetchPayments();
  }
  const goToTripView = (data) => {
    if(data && data.journeyId){
      history.push({
        pathname: `/trips/view/${data.journeyId}`,
        state: {
          id: 7,
          tripData: data,
          tripView: true,
          pageTitle: 'Trip Details',
          pageSubTitle: data && data.vehicleNumber ? data.vehicleNumber : ''
        }
      });
    }
  }
  useEffect(() => {
    fetchPayments();
  }, [dispatchGetSinglePartyTripSparkLine]);

  useEffect(() => {

    setPartyPaymentLedger([]);
    setLoadingText("Loading........");
    if (changeFlag) {
      setCurrentPageNo(defaultPageNo)
      fetchPayments();
    }

  }, [selectedFilterTransaction, selectedFilterDate, customFilterValue]);

  useEffect(() => {

    if (parties && parties.singlePartyPayments && parties.singlePartyPayments.payments) {
      setPartyPaymentLedger(parties.singlePartyPayments.payments);
    }

  }, [parties.singlePartyPayments])

  const handleRowClick = (paymentData) => {
    if(paymentData && !paymentData.openingBalanceId){
      setPaymentSideBar(true);
      setPaymentRowData(paymentData);
    }else if (paymentData && paymentData.openingBalanceId) {
      setSelectedRow({
        ...paymentData,
        date:paymentData&&paymentData.sorDate? Math.round(new Date(paymentData.sorDate).getTime()/1000):null,
        startTime:paymentData&&paymentData.sorDate? Math.round(new Date(paymentData.sorDate).getTime()/1000):null
      });
      setDetailsOpen(true)
    }
  }
  const handlePassbookClose = () => {
    setPassbookPdfOpen(false);
  }
  const handlePartyPdf = () => {
    setPassbookPdfOpen(true);
  }

  const muiData = partyPaymentLedger ? partyPaymentLedger : [];
  const muiColumns = [
    {
      name: "sorDate",
      label: "Date",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          let parsed = muiData[dataIndex];
          if (rowIndex === muiData.length - 3) {
            return (
              <Fragment>
                <Waypoint
                  onEnter={() => {
                    if (parties && parties.singlePartyPayments && parties.singlePartyPayments.maxPage && parties.singlePartyPayments.maxPage != currentPageNo) {
                      getPaginatedData()
                      setCurrentPageNo(currentPageNo + 1)
                    }
                  }}
                />
                <span className={classes.fwNormal}>{parsed.date ? parsed.date : null}</span>
              </Fragment>
            );
          } else {
            return <span className={classes.fwNormal}>{parsed.date ? parsed.date : null}</span>
          }
        }
      },
    },
    {
      name: "transactionName",
      label: "Trip Details",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          const detailsData = muiData[dataIndex]
          return (
            <>
              {detailsData && detailsData.tripDetails && (detailsData.tripDetails.transactioNumber || detailsData.tripDetails.trips) &&
                <div className={classes.divAlignV1}>
                  <div className={classes.fwBold}>{muiData[dataIndex] && muiData[dataIndex].transactionName ? muiData[dataIndex].transactionName : ""}</div>
                  {detailsData.isBrokerEnabled &&
                    <>
                      <CheckCircleIcon className={classes.doneV1} />
                      <div className={classes.divTranstNo}>{detailsData.tripDetails.transactioNumber ? detailsData.tripDetails.transactioNumber : ""}</div>
                    </>
                  }
                  {detailsData.tripDetails.trips &&
                    <>
                      <FiberManualRecordIcon className={classes.dotV1} />
                      <div className={classes.tripInfo} >{detailsData.tripDetails.trips}</div>
                    </>
                  }
                </div>
              }
              {detailsData && detailsData.tripDetails && !detailsData.tripDetails.trips && !detailsData.tripDetails.vehicleNumArrayDweb && !detailsData.tripDetails.transactioNumber &&
                <div className={classes.divAlignV1}>
                  <div className={classes.fwBold}>
                    {muiData[dataIndex] && muiData[dataIndex].transactionName ? muiData[dataIndex].transactionName : ""}
                    {muiData[dataIndex] && muiData[dataIndex].openingBalanceId ? `: ${numberFormat(Number(muiData[dataIndex].amount))}` : ""}
                  </div>
                </div>
              }
              {detailsData && detailsData.tripDetails && detailsData.tripDetails.vehicleNumArrayDweb &&
                <div className={classes.divAlignV1}>
                  <div className={classes.divVehicleNumber}>
                    {detailsData.tripDetails.vehicleNumArrayDweb.map((vehicleNumber) => (
                      <div>
                        {vehicleNumber}
                      </div>
                    ))}
                  </div>
                  <FiberManualRecordIcon className={classes.dotV1} />
                  <div className={classes.fwBold}>{detailsData.transactionName ? detailsData.transactionName : ""}</div>
                </div>
              }
            </>
          )
        }
      },
    },
    {
      name: "amount",
      label: "Payment",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return muiData[dataIndex] && muiData[dataIndex].amount && muiData[dataIndex].transactionParentType ? <div className={classes.divText}>{numberFormat(Number(muiData[dataIndex].amount))}</div> : ''
        },
        customHeadRender: (columnMeta) => (
          <th key={2} className={classes.thTruckRightAlign}>
            {columnMeta.label}
          </th>
        )
      },
    },
    {
      name: "revenue",
      label: "Revenue",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return muiData[dataIndex] && muiData[dataIndex].amount && muiData[dataIndex].tripId ? <div className={classes.balance}>{numberFormat(Number(muiData[dataIndex].amount))}</div> : '';
        },
        customHeadRender: (columnMeta) => (
          <th key={3} className={classes.thTruckRightAlign}>
            {columnMeta.label}
          </th>
        )
      },
    },
  ];
  const options = {
    rowsPerPage: 100,
    pagination: false,
    rowsPerPageOptions: [10, 100, 250],
    filterType: "multiselect",
    fixedHeader: true,
    tableBodyHeight: tableHeightWithSparklineSingle,
    selectableRows: 'none',
    searchOpen: true,
    search: false,
    jumpToPage: false,
    download: false,
    filter: false,
    print: false,
    viewColumns: false,
    /*sortOrder: {
      name: 'sorDate',
      direction: 'desc'
    },*/
    onRowClick: (data, row) => {

      if (row) {
        let tableData = muiData[row.dataIndex];
        // if (tableData && tableData.transactionParentType && tableData.transactionParentType == 'PAYMENT' && !tableData.isBrokerEnabled) {
        //   handleEditPartyPaymentOpen(tableData);
        // } else if (tableData && tableData.transactionParentType && tableData.transactionParentType == 'ADVANCE') {
        //   handleEditPartyAdvanceOpen(tableData);
        // } else
        if (tableData && tableData.tripId && !tableData.isBrokerEnabled) {
          goToTripView(tableData);
        } else {
          handleRowClick(tableData);
        }

      }
    },
    customToolbar: (data) => {
      return <>
        <div className={classes.divV1}>
          <div className={classes.mtV3}>
            <span>
              <DateFilter dateValue={handleDateValue} fromSinglePartyPaymentTab={true} />
            </span>
            <span className={classes.mlV2}>
              <PaymentTabFilter filterValue={handlePaymentFilterValue} />
            </span>
          </div>
          <Button variant="contained" classes={{ root: classes.viewPDFCta, label: classes.label, }} color="primary" onClick={() => { handlePartyPdf() }}>
            <PictureAsPdfIcon />&nbsp;View PDF
          </Button>
        </div>
      </>
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {

    },

    customSearch: (searchQuery, currentRow, columns) => {
      let isFound = false;
      /*if (searchQuery && searchQuery.trim().length > 0) {
        searchQuery = searchQuery.trim()
        currentRow.forEach((col, index) => {
          if (col && col.toString().toLowerCase().indexOf(searchQuery.toLowerCase()) >= 0) {
            isFound = true;
          }
        });
      } else {
        isFound = true;
      }*/
      return true;
    },

    searchProps: {
      variant: "outlined",
      //value: searchText,
      InputProps: {
        startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
      },
      onBlur: (e) => {
      },
      onKeyUp: (e) => {
      },
      onKeyDown: (event) => {
        if (event.keyCode === 27) {
        }
      }
    },

    onSearchChange: (val) => {
      let value = val ? !val.replace(/\s/g, '').length ? val.trim() : val : "";
      setSearchText(value);
      if (value && value.length > 1) {
        onSearchBlur(value);
      } else if (searchText && value && value.trim().length <= 1) {
        setSearchText("");
        onSearchBlur("null");
      } else {
        setSearchText("");
        onSearchBlur("null");
      }
    },
    searchPlaceholder: 'Search Payment',
    textLabels: {
      body: {
        noMatch: loadingText,
        toolTip: "Sort",
        columnHeaderTooltip: column => `Sort for ${column.label}`
      }
    }
  };

  const handleDateValue = (value) => {
    if (value == "CUSTOM") {
      setCustomFilter(true);
    } else {
      setSelectedFilterDate(value);
      setCustomFilter(false);
      setCustomFilterValue({});
    }

    dispatchUpdatePaymentsTabFilter({
      selectedFilterDate: value,
      selectedFilterTransaction: value
    });
    setChangeFlag(true);
  }

  const handlePaymentFilterValue = (value) => {
    setSelectedFilterTransaction(value);
    dispatchUpdatePaymentsTabFilter({
      selectedFilterDate: selectedFilterDate,
      selectedFilterTransaction: value
    });
    setChangeFlag(true);
  }

  const handleCustomFilterClose = () => {
    setCustomFilter(false);
  }

  const handleCustomFilterConfirm = (value) => {
    setSelectedFilterDate("CUSTOM");
    setCustomFilter(false);
    setCustomFilterValue(value);
  }


  const handlePaymentSideBarClose = () => {
    setPaymentSideBar(false);
    fetchPayments();
  }

  const handlePaymentDelete = () => {
    fetchPayments();
    setPaymentSideBar(false);
  }

  return (<>
    <TapLayout>
      <Grid container justify="flex-start" spacing={3} direction="row" alignItems="center">
        <Grid item>
          <TopCard title='Trip Revenue' color="#0b1323" infoIcon={true} cardValue={numberFormat(parties && parties.singlePartyTripSparkLine && parties.singlePartyTripSparkLine.totalRevenue ? parties.singlePartyTripSparkLine.totalRevenue : 0)} infoTitle={"Trip Revenue"} infoText={"The total revenue from all the trips with this party.\nTrip Revenue = Freight Amount + Party Charges - Party Deductions"} />
        </Grid>
        <Grid item>
          <TopCard title='Trip Payments' color="#6b778c" infoIcon={true} cardValue={numberFormat(parties && parties.singlePartyTripSparkLine && parties.singlePartyTripSparkLine.totalPaymentReceived ? parties.singlePartyTripSparkLine.totalPaymentReceived : 0)} infoTitle={"Trip Payments"} infoText={"The total payments received from all the trips with this party"} />
        </Grid>
        <Grid item>
          <TopCard title='Trip Balance' color="#00875a" infoIcon={true} cardValue={numberFormat(parties && parties.singlePartyTripSparkLine && parties.singlePartyTripSparkLine.totalBalance ? parties.singlePartyTripSparkLine.totalBalance : 0)} infoTitle={"Trip Balance"} infoText={"The total balance from all the trips with this party.\nTotal Balance = Total Revenue - Total Payments"} />
        </Grid>
      </Grid>
      <div>
        <MUIDataTable title={""} data={muiData} columns={muiColumns} options={options} />
      </div>
    </TapLayout>

    {/* {editPartyPaymentOpen && <EditPartyPayment sideBarTitle="Update Party Payment" sideBarOpen={editPartyPaymentOpen} sideBarClose={handleEditPartyPaymentClose} onSave={handleEditPartyPaymentSave} />} */}

    {paymentSideBar &&
      <PaymentDetailsSideBar invokedFrom={"passBookTabParty"} open={paymentSideBar} onClose={handlePaymentSideBarClose} paymentData={paymentRowData} onDelete={handlePaymentDelete} />
    }
    {passbookPdfOpen &&
      <PassBookReportDialog open={passbookPdfOpen} name={"Export Party Passbook Report"} fromSinglePartyPage={true} partyIdFromSingleParty={partId} onClose={handlePassbookClose} />
    }
    {editPartyAdvanceOpen && <TripActionDialog action={editPartyAdvance} editData={cashFlowItem} open={editPartyAdvanceOpen} onClose={handleEditCashflowActionClose} onUpdateSuccess={handleOnUpdateSuccess} confirmText={editPartyAdvance.confirmText ? editPartyAdvance.confirmText : null} />}
    {customFilter && <CustomDateFilterDialog open={customFilter} onClose={handleCustomFilterClose} onConfirm={handleCustomFilterConfirm} />}
    {detailsOpen && <OpeningBalanceDetailsSideBar rightSideBarOpen={detailsOpen} onClose={handlePaymentDetailsClose} selectedRow={selectedRow} onDelete={handleTransactDelete} />}
  </>)
};
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchGetSinglePartyTripSparkLine: (requestData, onSuccess, onFailure) => dispatch(getTripSparkLine(requestData, onSuccess, onFailure)),
  dispatchGetSinglePartyPayments: (requestData, onSuccess, onFailure) => dispatch(getPartyPayments(requestData, onSuccess, onFailure)),
  dispatchGetSinglePartyPaymentDetails: (partyId, paymentId, onSuccess, onFailure) => dispatch(getSinglePartyPaymentDetails(partyId, paymentId, onSuccess, onFailure)),
  dispatchUpdatePaymentsTabFilter: (data) => dispatch(updatePaymentsTabFilter(data)),

});
const PaymentsTabWithRouter = withRouter(PaymentsTab);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentsTabWithRouter);
